import { render, staticRenderFns } from "./CoffeeOrder.vue?vue&type=template&id=4c21b249&scoped=true"
import script from "./CoffeeOrder.vue?vue&type=script&lang=js"
export * from "./CoffeeOrder.vue?vue&type=script&lang=js"
import style0 from "./CoffeeOrder.vue?vue&type=style&index=0&id=4c21b249&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c21b249",
  null
  
)

export default component.exports